// reducer.js
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};

const registerSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    registerUserSuccessful(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
      state.registrationError = null;
    },
    registerUserFailed(state, action) {
      state.loading = false;
      state.error = true;
      state.success = false;
      state.registrationError = action.payload;
    },
    resetRegisterFlagChange(state) {
      state.success = false;
      state.error = false;
      state.registrationError = null;
    },
    apiErrorChange(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    }
  },
  extraReducers: (builder) => {
    // Add error handling for specific error types here
    builder
      .addCase(registerUserFailed.type, (state, action) => {
        if ('password1' in action.payload && Array.isArray(action.payload.password1)) {
          state.registrationError = `Password: ${action.payload.password1[0]}`;
        } else {
          state.registrationError = action.payload.message || 'Registration failed';
        }
      });
  }
});

export const {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
  setLoading
} = registerSlice.actions;

export default registerSlice.reducer;
